import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { ScreenStore } from '../../stores/ScreenStore';
import { constants } from '../../config';
import { HomeNavbar } from '../../common/home-navbar';
import { Footer } from '../../common/footer';
import { SearchStore } from '../../stores/SearchStore';
import { ParamsHelper } from '../../helpers/ParamsHelper';
import { ProductList } from './product-list';
import { ProductMobileList } from './product-mobile-list';
import { Filters } from './filters';
import styles from './Search.css';
import { CompareSection } from '../../common/compare-section/CompareSection';
import { SEO } from '../../common/seo';
import { GA4 } from '../../helpers/GA4';

const IPropTypes = {
  location: PropTypes.shape({
    search: PropTypes.string.isRequired,
  }).isRequired,
};

class Search extends React.Component {
  componentDidMount() {
    this._searchProducts(3);
  }

  componentDidUpdate() {
    this._searchProducts();
  }

  _searchProducts(filter) {
    const {
      q: query,
      filter: queryFilter,
      st: suggestionType,
      si: suggestionId,
    } = ParamsHelper.parseQueryParams(this.props.location.search);
    SearchStore.search(query, filter || queryFilter, suggestionType, suggestionId);
    GA4.searchEvent(query);
  }

  render() {
    const showMobileVersion = ScreenStore.screenWidth <= constants.breakpoints.smallMaxWidth;
    return (
      <div>
        <div className={styles.container}>
          <SEO
            title="Resultados de Búsqueda"
            description="Explora los resultados de búsqueda en [nombre de tu sitio web] para encontrar la información más relevante y actualizada. Nuestra plataforma te ofrece una amplia variedad de contenido, desde artículos y productos hasta servicios especializados, todo organizado para facilitar tu búsqueda. Encuentra rápidamente lo que necesitas con nuestras opciones de filtrado y búsqueda avanzada. Navega por categorías y resultados destacados para una experiencia de usuario más eficiente. Si buscas algo específico, utiliza nuestras herramientas para refinar tu búsqueda y obtener los mejores resultados"
            type="website"
          />
          <HomeNavbar />
          <CompareSection />
          <div className={styles.internalContainer}>
            { !showMobileVersion &&
            <div className={styles.contentWrapper}>
              <Filters className={styles.filters} />
              <ProductList className={styles.productList} />
            </div>
            }
            { showMobileVersion &&
            <div className={styles.contentWrapper}>
              <ProductMobileList className={styles.productList} />
            </div>
            }
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const ObservedSearch = observer(Search);

Search.propTypes = IPropTypes;

export { ObservedSearch as Search };



// WEBPACK FOOTER //
// ./src/pages/search/Search.jsx